import { createContext, useContext } from "react"

import { DATE_FORMAT } from "../utils/date/date.ts"

const DateFormatContext = createContext(DATE_FORMAT)

const useDisplayDateFormat = () => useContext(DateFormatContext)

export { DateFormatContext, useDisplayDateFormat }
